import { message } from "antd";
import InternalApi from "../axios/internalApi";

export const getAds = async (pageNumber, pageSize) => {
  try {
    return await InternalApi.get({
      server: "api/v1/",
      path: `admin/list-advertisements?pageNumber=${pageNumber}&itemPerPage=${pageSize}`,
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};
export const approveAds = async (id) => {
  try {
    return await InternalApi.patch({
      server: "api/v1/",
      path: `admin/advertisement?id=${id}`,
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};
export const rejectAd = async (id) => {
  try {
    return await InternalApi.patch({
      server: "api/v1/",
      path: `admin/reject-advertisement?id=${id}`,
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const deleteAdvertisement = async (id) => {
  try {
    return await InternalApi.delete({
      server: "api/v1/",
      path: `admin/advertisement/${id}`,
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const updateAdvertisement = async (id, data) => {
  try {
    return await InternalApi.patch({
      server: "api/v1/",
      path: `admin/advertisement/${id}`,
    }, data);
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const getAdvertisementTypes = async () => {
  try {
    return await InternalApi.get({
      server: "api/v1/",
      path: `advertisement/advertisement-type-list`,
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const getOfferTypes = async () => {
  try {
    return await InternalApi.get({
      server: "api/v1/",
      path: `advertisement/offer-type-list`,
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};
